import React from 'react';
import { Global } from '@creditas-ui/system';
import { createGlobalStyles } from './createGlobalStyles';
export var CSSBase = _ref => {
  var {
    custom = ''
  } = _ref;
  return /*#__PURE__*/React.createElement(Global, {
    styles: theme => createGlobalStyles(theme, custom)
  });
};
//# sourceMappingURL=CSSBase.js.map